import { z } from 'zod';
import { requiredString } from '../helpers';
/**
 * Salesforce Update Campaign Member v1 Configuration Validator
 * Validates Salesforce campaign member update configuration
 */
export const Salesforce_Update_Campaign_Member_1_ConfigValidator = z.object({
    connection: requiredString('Salesforce Connection is required'),
    campaignMemberId: requiredString('Campaign Member ID is required'),
    status: requiredString('Status is required')
});
//# sourceMappingURL=salesforce-update-campaign-member-1.js.map